var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('AbaFiltro',{attrs:{"titulo":_vm.titulo}},[_c('rnp-multiselect',{staticStyle:{"padding-bottom":"28px"},attrs:{"propsMultiselect":{
      placeholder: 'Unimed',
      options: _vm.listaUnimeds,
      'track-by': 'id',
      label: 'textoExibicao'
    }},model:{value:(_vm.objetoFiltro.unimeds),callback:function ($$v) {_vm.$set(_vm.objetoFiltro, "unimeds", $$v)},expression:"objetoFiltro.unimeds"}}),_c('rnp-multiselect',{attrs:{"propsMultiselect":{
      placeholder: 'Estados',
      options: _vm.listaEstados,
      'track-by': 'chave',
      label: 'descricao'
    }},model:{value:(_vm.objetoFiltro.estados),callback:function ($$v) {_vm.$set(_vm.objetoFiltro, "estados", $$v)},expression:"objetoFiltro.estados"}}),_c('template',{slot:"botao"},[_c('unicom-botao',{attrs:{"desabilitado":!_vm.habilitado,"largura":360,"altura":40},on:{"click":_vm.proximaAba}},[_vm._v(" CONTINUAR ")])],1)],2):_c('unicom-spinner',{staticStyle:{"min-height":"450px","display":"flex","flex-flow":"wrap column","justify-content":"center"},attrs:{"tamanhoLoading":62,"tamanhoLinha":7,"velocidade":0.5,"marginTopTexto":30,"mensagem":"Carregando..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }